import { get } from 'helpers/api_helper'
import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import { CardSkeletonLoader } from "modules/loader"

const MiniWidget = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  
  useEffect(async() => {
    try {
      setLoading(true)
      const res = await get(`api/org/gettotals`)
      if (res && res?.status == 200 && Array.isArray(res.response)) {
        setData(res.response)
      } else if (Array.isArray(res)) {
        setData(res)
      }
    } catch (err) {
      console.error("MiniWidget error:", err)
    } finally {
      setLoading(false)
    }
  }, [])

  if (loading || !data) {
    return <CardSkeletonLoader count={4} sm={3} />
  }

  return (
    <React.Fragment>
      <Row className="fade-in-content">
        {data && data.map((report, key) => (
          <Col xl="3" lg="6" sm="6" xs="12" key={key} className="mb-4">
            <Card className="h-100 shadow-sm border-0">
              <CardBody>
                <div className="d-flex align-items-center mb-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                      <i className={report.icon || 'bx bx-chart'} />
                    </span>
                  </div>
                  <h5 className="font-size-14 mb-0">{report.title}</h5>
                </div>
                <div className="text-muted mt-4">
                  <h4 className="fw-bold mb-2">
                    {report.value}{" "}
                    <i className="mdi mdi-chevron-up ms-1 text-success" />
                  </h4>
                  <div className="d-flex align-items-center">
                    <span className="me-2 text-truncate font-size-12">{report.desc}</span>
                    <span
                      className={
                        "badge badge-soft-" + (report.color || 'primary') + " font-size-12 ms-auto"
                      }
                    >
                      {report.badgeValue}
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  )
}

export default MiniWidget
